import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Tus consentimientos',
  empty: 'No hay solicitudes de consentimiento que te afecten.',
  collectiveNote:
    'Hay un registro colectivo vigente en el departamento; tu respuesta personal no tiene efecto mientras esté vigente.',
  table: {
    department: 'Departamento',
    status: 'Estado',
    basis: 'Base vigente',
  },
  status: {
    pending: 'A la espera de tu respuesta',
    granted: 'Concedido',
    denied: 'Denegado',
  },
  basis: {
    personal: 'Personal',
    collective: 'Colectiva',
  },
  actions: {
    grant: 'Conceder',
    deny: 'Denegar',
    withdraw: 'Retirar',
  },
};
